module.exports = __webpack_public_path__ + "media/images/features/draft/thumb-voice-3-5918d6f17545975337bc996732cb27ef.jpg";